import { BrowserAdapter } from './adapter.mjs';

const settings = {
  ADAPTER: BrowserAdapter,
  RESOLUTION: 1,
  CREATE_IMAGE_BITMAP: false,
  ROUND_PIXELS: false
};

export { settings };
//# sourceMappingURL=settings.mjs.map
